import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout'
import { pcRoutes } from './pc.js'
// import { mRoutes } from './m.js'
import { isMobile } from '@/utils/common.js'
import iaaSdk from '@/utils/iaa_sdk'

const currentRoutes = isMobile() ? pcRoutes : pcRoutes;
const routes = [
  {
    path: '',
    component: Layout,
    redirect: '/index',
    children: currentRoutes
  },
  // {
  //   path: '/order-info',
  //   component: () => import('@/views/record/order.vue'),
  //   hidden: true
  // },
  // {
  //   path: '/order-result',
  //   component: () => import('@/views/record/result.vue'),
  //   hidden: true
  // },
  {
  	  path: '/payali/:id/:platid?',
  	  component: () => import('@/views/pay/payali.vue'),
  	  name: 'Payali',
  	  meta: { title: '支付' },
  },
  {
  	  path: '/payresult/:id/:orderNo/:platid?',
  	  component: () => import('@/views/pay/payresult.vue'),
  	  name: 'Payresult',
  	  meta: { title: '支付' },
  },
  {
  	  path: '/wxcode',
  	  component: () => import('@/views/pay/wxcode.vue'),
  	  name: 'Wxcode',
  	  meta: { title: '支付' },
  },
  {
  	  path: '/iaasdk',
  	  component: () => import('@/views/iaa/adpopup.vue'),
  	  name: 'Iaasdk',
  	  meta: { title: '广告福利' },
  },
  {
  	  path: '/gmsdk',
  	  component: () => import('@/views/gmtools/index.vue'),
  	  name: 'Gmsdk',
  	  meta: { title: 'GM工具' },
  },
  {
  	  path: '/gmiaa',
  	  component: () => import('@/views/gmtools/adgift.vue'),//adpopup旧版备份，adgift最新版
  	  name: 'Gmiaa',
  	  meta: { title: 'GM广告' },
  },
  {
  	  path: '/super-luckysdk',
  	  component: () => import('@/views/gmtools/luckysdk.vue'),
  	  name: 'SuperLuckysdk',
  	  meta: { title: '幸运礼包' },
  },
  // {
  // 	  path: '/gmiaaGift',
  // 	  component: () => import('@/views/gmtools/adgift.vue'),
  // 	  name: 'GmiaaGift',
  // 	  meta: { title: 'GM广告' },
  // },
  {
    path: "/:pathMatch(.*)*",
    component: () => import('@/views/error/404.vue'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401.vue'),
    hidden: true
  },
]

const router = createRouter({
	mode:'history',
	routes,
	history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

// 2496专属:广告福利类页面(GM广告/幸运礼包)统一改走 /iaasdk 专属图,守卫层集中拦,比单页 onMounted 更早。
// 拿不到 gameId(加密串还没到)就放行,由目标页 onMounted/watch 兜底,不影响其他游戏。
router.beforeEach((to, from, next) => {
	if(to.name === 'Gmiaa' || to.name === 'SuperLuckysdk'){
		try{
			let infos = iaaSdk.sdkGetInfos() || {}
			if(infos.gameId == '2496'){
				return next({ name: 'Iaasdk', query: to.query })
			}
		}catch(e){
			console.log('2496守卫判断异常', e)
		}
	}
	next()
})

export default router
